import * as React from "react";
import { iPlan } from "@/interfaces/plans";
import { Message } from "@/components/feedback";
import { Table } from "@/components/table";
import { HTML } from "@/components/content";

export interface iProps {
  plan: iPlan;
}

/**
 * Renders information about a deactivated plan.
 */
export default function DeactivatedPlanInfo(props: iProps): React.ReactElement {
  const { plan } = props;

  if (!plan.deactivated_at) {
    return null;
  }

  const tableCols = [
    {
      label: "",
      key: "item",
    },
    {
      label: "",
      key: "value",
    },
  ];

  const rows = [
    {
      item: "Name",
      value: plan.name,
    },
    {
      item: "Price",
      value: `£${(plan.price / 100).toFixed(2)}`,
    },
    {
      item: "Permissions",
      value: plan.permissions.join(", "),
    },
    {
      item: "Deactivated at",
      value: plan.deactivated_at,
    },
  ];

  return (
    <div className="deactivated-plan">
      <Message theme="warning">This plan has been deactivated.</Message>

      <Table columns={tableCols} rows={rows} />

      <h5>Benefits</h5>
      <HTML value={plan.description} />
    </div>
  );
}
